import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _I3SCatalogItem;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import i18next from "i18next";
import { computed, makeObservable, observable, override, runInAction, toJS } from "mobx";
import ArcGISTiledElevationTerrainProvider from "terriajs-cesium/Source/Core/ArcGISTiledElevationTerrainProvider";
import BoundingSphere from "terriajs-cesium/Source/Core/BoundingSphere";
import Cartesian2 from "terriajs-cesium/Source/Core/Cartesian2";
import Resource from "terriajs-cesium/Source/Core/Resource";
import Cesium3DTileColorBlendMode from "terriajs-cesium/Source/Scene/Cesium3DTileColorBlendMode";
import I3SDataProvider from "terriajs-cesium/Source/Scene/I3SDataProvider";
import isDefined from "../../../Core/isDefined";
import CatalogMemberMixin, { getName } from "../../../ModelMixins/CatalogMemberMixin";
import Cesium3dTilesStyleMixin from "../../../ModelMixins/Cesium3dTilesStyleMixin";
import FeatureInfoUrlTemplateMixin from "../../../ModelMixins/FeatureInfoUrlTemplateMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import ShadowMixin from "../../../ModelMixins/ShadowMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import I3SCatalogItemTraits from "../../../Traits/TraitsClasses/I3SCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
import TerriaFeature from "../../Feature/Feature";
let I3SCatalogItem = (_class = (_I3SCatalogItem = class I3SCatalogItem extends Cesium3dTilesStyleMixin(FeatureInfoUrlTemplateMixin(ShadowMixin(MappableMixin(UrlMixin(CatalogMemberMixin(CreateModel(I3SCatalogItemTraits))))))) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "type", I3SCatalogItem.type);
    _initializerDefineProperty(this, "dataProvider", _descriptor, this);
    makeObservable(this);
  }
  get boundingSphere() {
    var _this$dataProvider;
    if ((_this$dataProvider = this.dataProvider) !== null && _this$dataProvider !== void 0 && _this$dataProvider.layers) {
      return BoundingSphere.fromBoundingSpheres(this.dataProvider.layers.map(layer => {
        var _layer$tileset;
        return (_layer$tileset = layer.tileset) === null || _layer$tileset === void 0 ? void 0 : _layer$tileset.boundingSphere;
      }).filter(isDefined));
    }
  }
  async forceLoadMapItems() {
    if (!isDefined(this.url)) {
      throw "`url` is not defined for ".concat(getName(this));
    }
    const resource = new Resource(this.url);
    if (this.token) {
      resource.appendQueryParameters({
        token: this.token
      });
    }
    const i3sProvider = await I3SDataProvider.fromUrl(resource, {
      showFeatures: this.allowFeaturePicking,
      geoidTiledTerrainProvider: this.terrainURL ? await ArcGISTiledElevationTerrainProvider.fromUrl(this.terrainURL) : undefined
    });
    runInAction(() => {
      this.dataProvider = i3sProvider;
    });
  }

  /**
   * This function should return null if allowFeaturePicking = false
   * @param _screenPosition
   * @param pickResult
   */
  buildFeatureFromPickResult(_screenPosition, pickResult) {
    if (this.allowFeaturePicking && isDefined(pickResult.content) && isDefined(pickResult.content.tile.i3sNode) && isDefined(pickResult.featureId) && _screenPosition) {
      const i3sNode = pickResult.content.tile.i3sNode;
      return i3sNode.loadFields().then(() => {
        const fields = i3sNode.getFieldsForFeature(pickResult.featureId);
        const result = new TerriaFeature({
          properties: fields
        });
        result._cesium3DTileFeature = pickResult;
        return result;
      });
    }
    return undefined;
  }
  get mapItems() {
    if (this.isLoadingMapItems || !isDefined(this.dataProvider)) {
      return [];
    }
    if (this.dataProvider.isDestroyed()) {
      this.forceLoadMapItems();
    }
    if (this.dataProvider) {
      this.dataProvider.show = this.show;
      this.dataProvider.layers.forEach(layer => {
        const tileset = layer.tileset;
        if (tileset) {
          tileset.style = toJS(this.cesiumTileStyle);
          tileset.shadows = this.cesiumShadows;
          // @ts-expect-error - Attach terria catalog item to tileset
          tileset._catalogItem = this;
          if (this.lightingFactor && tileset.imageBasedLighting) {
            tileset.imageBasedLighting.imageBasedLightingFactor = new Cartesian2(...this.lightingFactor);
          }
          const key = this.colorBlendMode;
          const colorBlendMode = Cesium3DTileColorBlendMode[key];
          if (colorBlendMode !== undefined) tileset.colorBlendMode = colorBlendMode;
          tileset.colorBlendAmount = this.colorBlendAmount;
        }
      });
    }
    return [this.dataProvider];
  }
  get shortReport() {
    if (this.terria.currentViewer.type === "Leaflet") {
      return i18next.t("models.commonModelErrors.3dTypeIn2dMode", this);
    }
    return super.shortReport;
  }
  get typeName() {
    return i18next.t("core.dataType.i3s");
  }
}, _defineProperty(_I3SCatalogItem, "type", "i3s"), _I3SCatalogItem), _descriptor = _applyDecoratedDescriptor(_class.prototype, "dataProvider", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "boundingSphere", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "boundingSphere"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shortReport", [override], Object.getOwnPropertyDescriptor(_class.prototype, "shortReport"), _class.prototype), _class);
export { I3SCatalogItem as default };